module.exports = __webpack_public_path__ + "img/1b7d89256d1887c92c86c5d1056a18a4.svg";